import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _CostingCenter, _MeasurementUnitCode } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { toast } from "react-toastify";
import { BasicTable, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { SelectBusinessCore } from "../BusinessCore/SelectBusinessCore";
import { BudgetCostingCenter } from "./BudgetCostingCenter/BudgetCostingCenter";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { SelectAccountantTree } from "../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { PayrollTypeSelect } from "../../../Talentohumano/ParametrosTalentoHumano/PayrollFactor/PayrollTypeSelect";

export const CostingCenter = () => {

    const { instance, lista, setLista, bean, setBean, deleteItemVoid, update, handleChange } = useDataBean(_CostingCenter);
    const [coreID, setCoreID] = useState<number>(NaN);

    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalModel, setModalModel] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });

    useEffect(() => {
        getLista()
    }, [])

    const getLista = () => {

        instance.getCostingCenterCatalog(coreID).then(
            (resp: any) => {
                if (resp) {

                    resp.forEach(element => {
                        element.DataBeanProperties.EntityCore = `${element.DataBeanProperties.BusinessCoreCode ? `${element.DataBeanProperties.BusinessCoreCode ?? "N/A"}-${element.DataBeanProperties.BusinessCoreName ?? "N/A"}` : "N/A"}`
                    });

                    setLista(resp)
                } else {
                    toast.error('NO hay datos')
                }

            }
        )

    }


    const create = () => {
        setBean({
            UseBudgetAccountantToPayroll: false,
            UseMappedCostBudgetID: false,
            UseMappedCostAccountantIDForExp: false,
            UseCostAccountantIDForExp: false
        });

        setModal({ ...modal, "view": true });
    }


    const deleteItem = () => {
        deleteItemVoid(bean.IDCostingCenter).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }


    const editaItem = () => {
        //console.log(CostingCenter.bean);
        update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }


    const head = [
        { title: 'ID', property: 'IDCostingCenter', visible: true, mask: MASK_NUMBER },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Cuenta Gasto/Costo para Traslados de Inventario', property: 'InventoryConsumptionIDStr', visible: true },
        { title: 'Utilizar Map a Nómina', property: 'UseBudgetAccountantToPayroll', visible: true },
        { title: 'Código Core/Unidad de Negocio', property: 'EntityCore', visible: true },
        { title: 'Utilizar Mapeo de Costo de Cuenta Contable', property: 'UseMappedCostAccountantIDForExp', visible: true },
        { title: 'Utilizar Map de Costo a Rubro Presupuestal', property: 'UseMappedCostBudgetID', visible: true },
        { title: 'Definir Cuenta de Costo para Todas las Cuentas', property: 'UseCostAccountantIDForExp', visible: true },
        { title: 'Cuenta de Costo para Todas las Cuentas', property: 'CostAccountantIDStr', visible: true },
        { title: 'Tipo de Payroll', property: 'PayrollTypeName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
            { titulo: 'Modelo Contable - Presupuestal', icono: 'ri-slideshow-line', visible: _single.canDelete(), evento: () => { setModalModel({ ...modalModel, "view": true, "name": "Modelo Contable - Presupuestal" }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Centros de Costo">
            <div className="row">
                <div className="col-md-6">
                    <SelectBusinessCore idSelector={coreID} onChange={(e) => { setCoreID(e) }} label="Código Core/Unidad de Negocio" />
                </div>
                <div className="col-md-6 mt-4">
                    <BasicButton icon="ri-search-line" eventClick={getLista} children={"Buscar"} />
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                </div>

                <div className="col-md-12">
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <label>Nombre</label>
                                    <input type="text" name="Name" className="form-control" value={bean.Name} onChange={handleChange} />

                                </div>

                                <div className="col-md-6">
                                    <label>Código</label>
                                    <input type="text" name="Code" className="form-control" value={bean.Code} onChange={handleChange} />

                                </div>

                                <div className="col-md-12">
                                    <label>Description</label>
                                    <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                                </div>
                                <div className="col-md-6">
                                    <SelectAccountantTree label="Cuenta Gasto/Costo para Traslados de Inventario" jsonCode={bean.InventoryConsumptionIDStr} onChange={(e) => { setBean({ ...bean, "InventoryConsumptionIDStr": e.JsonCode }) }} />
                                </div>
                                <div className="col-md-6">
                                    <BasicSwitch estado={bean.UseBudgetAccountantToPayroll} eventChange={(e) => { setBean({ ...bean, "UseBudgetAccountantToPayroll": e }) }} label="Utilizar Mapeo Contable/Presupuestal a Liquidación de Nómina" />
                                </div>
                                <div className="col-md-6">
                                    <SelectBusinessCore idSelector={bean.IDBusinessCore} onChange={(e) => { setBean({ ...bean, "IDBusinessCore": e }) }} label="Código Core/Unidad de Negocio" />
                                </div>
                                <div className="col-md-6">
                                    <BasicSwitch estado={bean.UseMappedCostAccountantIDForExp} eventChange={(e) => { setBean({ ...bean, "UseMappedCostAccountantIDForExp": e }) }} label="Utilizar Mapeo de Costo de Cuenta Contable" />
                                </div>
                                <div className="col-md-6">
                                    <BasicSwitch estado={bean.UseMappedCostBudgetID} eventChange={(e) => { setBean({ ...bean, "UseMappedCostBudgetID": e }) }} label="Utilizar Map de Costo a Rubro Presupuestal" />
                                </div>
                                <div className="col-md-6">
                                    <BasicSwitch estado={bean.UseCostAccountantIDForExp} eventChange={(e) => { setBean({ ...bean, "UseCostAccountantIDForExp": e }) }} label="Definir Cuenta de Costo para Todas las Cuentas" />
                                </div>
                                {bean.UseCostAccountantIDForExp &&
                                    <div className="col-md-6">
                                        <SelectAccountantTree jsonCode={bean.CostAccountantIDStr} onChange={(e) => { setBean({ ...bean, "CostAccountantIDStr": e.JsonCode }) }} label="Cuenta de Costo para Todas las Cuentas" />
                                    </div>
                                }
                                <div className="col-md-12">
                                    <PayrollTypeSelect idSelector={bean.IDPayrollType} onChange={(e) => { setBean({ ...bean, "IDPayrollType": e }) }} />
                                </div>
                            </div>
                        </>
                    </Modal>
                </div>

                <div className="col-md-12">
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

                <div className="col-md-12">
                    <Modal modal={modalModel} updateModal={setModalModel} >
                        <BudgetCostingCenter idCostingCenter={bean.IDCostingCenter} />
                    </Modal>
                </div>

            </div>
        </BasicPage>
    )
}